<template>
  <div>
    <div v-if="isResult">

      <Result></Result>

    </div>
    <div v-else>

      <div class="modal__shindanContent">
        <div class="modal__shindanContentCell">

          <Quasution></Quasution>

        </div>
      </div>
      <Bar></Bar>

    </div>
  </div>
</template>

<script>
import Quasution from './Quasution.vue'
import Bar from './Bar.vue'
import Result from './Result.vue'
// import List from './List.vue'

export default {
  name: 'App',
  components: {
    Quasution,
    Bar,
    Result,
  },
  data () {
    return {
      // parentData: 'parentDataです'
    }
  },
  computed : {
    isResult : function(){
      return this.$store.state.userSelect.resultId;
      // return './share/images/shindan_q'+this.$store.state.userSelect.currentQnum+'.svg';
    }
  },

  // methods: {
  //     parentMethod: function(fromChildVal){
  //         // alert('親がイベントを受け取った');
  //         console.log(fromChildVal);
  //     }
  // }
}
</script>

<style>
</style>
